import {Checkbox, DatePicker, Input, Radio, Space} from 'antd'
import {useFormikContext} from 'formik'
import _ from 'lodash'
import React from 'react'
import {parseDayjs} from '../../helpers/datetimeHelpers'
import useTranslate from '../../modules/local/useTranslate'
import {renderIf} from '../../views/Shared'
import HeaderGroupItem from "../ItemLayout/HeaderGroupItem";
import {IoCalendarOutline} from "react-icons/io5";
import dayjs from "dayjs";

const {TextArea} = Input

const DynamicFieldUtilization = ({items, index, handleChange}) => {
    const t = useTranslate()
    const {values, setValues} = useFormikContext()
    const onTouch = () => {
    }
    const onUpdate = (name, value) => {
        setValues({...values, updated: Date.now()}).then((e) => {
            let _items = _.cloneDeep(items)
            _items[index] = {...items[index], [name]: value}
            handleChange(_items)
        })
    }
    const onDebouncedUpdate = _.debounce(onUpdate, 300);

    return (
        <div
            key={items[index]?.id}
            className="flex flex-col gap-2">
            <div className="flex flex-col">
                <div className="font-bold text-sm flex flex-wrap gap-1">
          <span>
            {`${index + 1})`}
          </span>
                    {renderIf(
                        !!items[index]?.is_mandatory,
                        <span className="text-red-500">*</span>
                    )}
                    <span>
            {`${items[index]?.title}`}
          </span>
                </div>
                <div className="ml-4 italic text-xs text-color-400 leading-tight">
                    {items[index]?.description}
                </div>
            </div>
            {renderIf(
                ['inputField'].includes(items[index]?.ctrl_type),
                <div className="flex flex-col gap-1 ml-2">
                    <Input
                        className="w-full rounded-md"
                        placeholder={t('content answer')}
                        showCount
                        maxLength={120}
                        onChange={(e) => {
                            onDebouncedUpdate('answer_value', e.target.value)
                        }}
                        defaultValue={items[index]?.answer_value}
                    />
                </div>
            )}
            {renderIf(
                ['textField'].includes(items[index]?.ctrl_type),
                <div className="flex flex-col gap-1 ml-2">
                    <TextArea
                        className="w-full"
                        placeholder={t('content answer')}
                        showCount
                        maxLength={500}
                        onChange={(e) => {
                            onDebouncedUpdate('answer_value', e.target.value)
                        }}
                        defaultValue={items[index]?.answer_value}
                    />
                </div>
            )}
            {renderIf(
                ['toggleField'].includes(items[index]?.ctrl_type),
                <div className="flex flex-row justify-end gap-1">
                    <Radio.Group
                        className="custom-radio-button"
                        options={[
                            {label: t('yes'), value: 1},
                            {label: t('no'), value: 0},
                        ]}
                        onChange={(e) => {
                            onDebouncedUpdate('answer_value', e.target.value)
                        }}
                        value={Number(items[index]?.answer_value) ?? 0}
                        optionType="button"
                        buttonStyle="solid"
                    />
                </div>
            )}
            {renderIf(
                ['dateField'].includes(items[index]?.ctrl_type),
                <div className="flex flex-row justify-end">
                    <DatePicker
                        placeholder={t('Select date')}
                        allowClear={true}
                        format="DD/MM/YYYY"
                        suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                        defaultValue={parseDayjs(items[index]?.answer_value ?? undefined)}
                        onChange={(date, dateString) => {
                            onDebouncedUpdate('answer_value', date ? dayjs(new Date(date)).format() : undefined)
                        }}
                    />
                </div>
            )}
            {renderIf(
                ['radioField'].includes(items[index]?.ctrl_type),
                <div className="flex flex-col gap-1 ml-2">
                    <Radio.Group
                        size="small"
                        onChange={(e) => {
                            onDebouncedUpdate('answer_value', e.target.value)
                        }}
                        value={items[index]?.answer_value}>
                        <Space
                            direction="vertical"
                            style={{rowGap: 4}}>
                            {(items[index]?.options ?? []).map((eee, iii) => (
                                <Radio
                                    key={iii}
                                    value={eee}>
                                    {eee}
                                </Radio>
                            ))}
                        </Space>
                    </Radio.Group>
                </div>
            )}
            {renderIf(
                ['checkboxField'].includes(items[index]?.ctrl_type),
                <div className="flex flex-col gap-1 ml-2">
                    <Checkbox.Group
                        onChange={(values) => {
                            onDebouncedUpdate('answer_value', values)
                        }}
                        value={items[index]?.answer_value ?? []}>
                        <Space
                            direction="vertical"
                            style={{rowGap: 4}}>
                            {(items[index]?.options ?? []).map((eee, iii) => (
                                <Checkbox
                                    key={iii}
                                    value={eee}>
                                    {eee}
                                </Checkbox>
                            ))}
                        </Space>
                    </Checkbox.Group>
                </div>
            )}
        </div>
    )
}


export const DynamicFieldsUtilWithRequiredForRegistration = ({
                                                                 name,
                                                                 value = [],
                                                                 onChange,
                                                                 className,
                                                                 ...rest
                                                             }) => {
    const t = useTranslate();

    const _value = value.length > 0 ? value.filter(e => !!e?.isRequiredForRegistration) : value;
    return (
        <div className="flex flex-col gap-2">
            {_value.map((el, i) => {
                return (
                    <DynamicFieldUtilization
                        key={i}
                        items={_value}
                        index={i}
                        handleChange={(val) => {
                            onChange(val)
                        }}
                    />
                )
            })}
        </div>
    )
}

const DynamicFieldsUtilization = ({
                                      name,
                                      value = [],
                                      onChange,
                                      className,
                                      ...rest
                                  }) => {
    // const [metadata, setMetadata] = useState(value);

    return (
        <div className="flex flex-col space-y-3">
            {renderIf(
                value.length > 0,
                <HeaderGroupItem title="manager information"/>
            )}
            {value.map((el, i) => {
                return (
                    <DynamicFieldUtilization
                        key={i}
                        items={value}
                        index={i}
                        handleChange={(val) => {
                            onChange(val)
                        }}
                    />
                )
            })}
        </div>
    )
}

export default DynamicFieldsUtilization
